import React from 'react'
import {component_tool, framework_tool} from "@/tool";
import moment from "moment";

const {modelUtils} = framework_tool;
const {WizBrowserExport, WizButton, WizModal} = component_tool

export const mapStateToProps = ({nameSpace, method}, state, ownProps) => {
  const list = modelUtils.getModelEntity(state[nameSpace], `${nameSpace}@${method}`);
  const headList = list.data && list.data.headList
  return {
    dynamicColumns: Array.isArray(headList) && headList.length ? headList : []
  }
};

export const handleExport = ({title, column, columnsType}, nextProps, nextState, key) => {
  let result = false;
  if (columnsType && columnsType) {
    result = true;
  }
  const res = nextProps[key]
  const {success, data = {}, msg} = res
  const {dataList = [], headList = []} = data
  if (success) {
    const rows = dataList.map(val => {
      return val
    });
    let type = nextProps?.apis?.exportTypeReport?.payload?.apiParams?.type;

    const formatterType = (val) => {
      let newVal;
      switch (val){
        case  1 : newVal ='4S网点'
          break;
        case  2 : newVal ='直营店'
          break;
        case  3 : newVal ='单一售后'
          break;
        case  4 : newVal ='单一销售'
          break;
        case  5 : newVal ='卫星店/直营店'
          break;
        case  6 : newVal ='自修站'
          break;
        case  7 : newVal ='卫星店'
          break;
        case  8 : newVal ='精品店'
          break;
        case  9 : newVal ='dealer'
          break;
        case  10 : newVal ='4S店'
          break;
        case  11: newVal ='汽车零售'
          break;
        case  12 : newVal ='单一销售展厅'
          break;
        case  13 : newVal ='NEV单一售后'
          break;
        case  14 : newVal = '轻量化4S网点'
          break;
        case  15 : newVal = 'NEV专区'
          break;
        case  16 : newVal = '商超店'
          break;
        case  17 : newVal = '自修店'
          break;
        case  18 : newVal = '二级网点'
          break;
        case  19 : newVal = '车工坊C1'
          break;
        case  20 : newVal = '车工坊C2'
          break;
        case  21 : newVal = '车工坊B'
          break;
        case  22 : newVal = '德科品牌授权经销商'
          break;
        case  99 : newVal = '暂定'
          break;
        default  : newVal = '无';
      }
      return newVal;
    };
    if (type) {
      title = title + "-"+formatterType(type);
    }
    let headList_ = [];
    if (headList && headList.length) {
      headList.forEach(val => {
        const {name, list} = val;
        if (list && list.length) {
          let list_new = [];
          list.forEach(val_ => {
            if (val_) {
              if (!result || (result && val_ && val_.name && (val_.name === '完成状态' || val_.name === '完成时间' || val_.name === '通过人数' || val_.name === '阶段完成率'))) {
                list_new.push(val_);
              }
            }
            val.list = list_new;
          })
        }
        headList_.push(val);
      })
    }
    const _columns = headList_.map(val => ({
      headerName: val.name,
      field: val.key,
      children: val.list && val.list.length ? val.list.map(val => ({
        headerName: val.name,
        field: val.key,
        children: val.list && val.list.length ? val.list.map(val => ({
          headerName: val.name,
          field: val.key,
        })) : undefined
      })) : undefined
    }))
    const formatterDateTime = (val) => {
      return val ? moment(val).format('YYYYMMDDHHmm') : '';
    }
    let dateTime = formatterDateTime(new Date());
    WizBrowserExport({
      title,
      sheetName: title,
      columns: column.filter((_, index) => index).concat(_columns),
      rows,
      filename: title +'-'+dateTime+ '.xlsx',
    })
    return true
  } else {
    wizNotice.error(msg)
    return false;
  }
}
